import hideDialog from './hideDialog';
import DialogName from '../constants/DialogName';
import { RootActionTypes } from '../../../stores/types';

function hideDeleteOptinMessageConfirm(): RootActionTypes {
  return hideDialog(DialogName.DELETE_OPTIN_MESSAGE_CONFIRM)();
}

export default hideDeleteOptinMessageConfirm;
